import { Router } from "./scripts/utils/router";
import { common } from "./scripts/routes/common";

// Include assets
import "./styles/main.css";
import "./images/icon-sprites.svg";

const routes = new Router({
	/** All pages*/
	common,
	/** Specific pages*/
});

/** Load Events */
routes.loadEvents();

/**
 * @see {@link https://webpack.js.org/api/hot-module-replacement/}
 */
// import.meta.webpackHot?.accept(console.error);
